let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dVPBt")).then(() => parcelRequire('bPcQU'));